import React from "react";
import { connect } from "react-redux";
import { Column } from "primereact/column"; 
import { OrderCargoBarcodesList } from "./OrderCargoBarcodesList";

const mapStateToProps = (state) => {
  const record = state.crudOrderDeliveryState.currentRecord;
  let barcodes = [];
  if (record && record.cargo && record.cargo.summary && record.cargo.summary.barcodes) {
    barcodes = record.cargo.summary.barcodes;
  }

  return {
    columns: state.crudOrderDeliveryState.columnsCargoBarcodes,
    records: barcodes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

class OrderCargoBarcodesListPageContainer extends React.Component {
  render() {
    const columns = this.props.columns.map((col) => {
      return <Column {...col} key={col.field} />;
    });

    return <OrderCargoBarcodesList {...this.props} columns={columns} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderCargoBarcodesListPageContainer);
